export function convertHexToRgb(hexColor) {
    const isValidHexColor = /^#([A-Fa-f0-9]{3}){1,2}$/.test(hexColor);
    if (!isValidHexColor) {
        throw new Error('Invalid HEX color code. Ensure it is a 3 or 6-character code.');
    }
    let red, green, blue;
    if (hexColor.length === 7) {
        red = parseInt(hexColor.slice(1, 3), 16);
        green = parseInt(hexColor.slice(3, 5), 16);
        blue = parseInt(hexColor.slice(5, 7), 16);
    }
    else {
        red = parseInt(hexColor[1] + hexColor[1], 16);
        green = parseInt(hexColor[2] + hexColor[2], 16);
        blue = parseInt(hexColor[3] + hexColor[3], 16);
    }
    return [red, green, blue];
}
export function convertHexToRgba(hexColor, opacityPercentage) {
    const color = convertHexToRgb(hexColor);
    if (!color) {
        return null;
    }
    const [red, green, blue] = color;
    const alpha = opacityPercentage / 100;
    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}
//# sourceMappingURL=color.js.map